import { useNavigate, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { OneModal } from '@factorialco/f0-react/dist/experimental'
import { FormsCustomTemplatesFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import FormsTemplatesDataCollection from 'modules/forms/components/FormsTemplatesDataCollection'
import {
  ColumnConfigurations,
  TableColumnType,
} from 'modules/forms/components/FormsTemplatesDataCollection/columnsHandler'
import { formFromData, useCreateForm } from 'modules/forms/hooks/useForms'

const SelectTemplateFormModal = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { id } = useParams()
  const handleCancel = () => {
    navigate(
      navigation.trainings.list.details_revamp.view.surveys.fullPath({
        id: Number(id),
      })
    )
  }
  const { createForm } = useCreateForm()
  const { company, access } = useCurrentSession()

  const itemOnClick = async (item: FormsCustomTemplatesFragment) => {
    const form = formFromData({
      ...item,
      status: 'draft',
      description: item.description ?? '',
      elements: item.elements.map((el) => ({
        ...el,
        description: item.description ?? '',
      })),
      resourceType: 'Trainings::Training',
      resourceId: id,
    })

    if (form) {
      const result = await createForm(form, company.id, access.id)

      if (result.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })
        navigate(
          navigation.trainings.list.details_revamp.trainingSurveyDetail.edit.fullPath({
            id: Number(id),
            formId: Number(result.data?.form?.id),
          })
        )
      }
    }
  }

  const columns = [TableColumnType.Name, TableColumnType.FormType]

  const configurations: ColumnConfigurations = {
    [TableColumnType.FormType]: {
      valueMapping: {
        satisfaction: i18n.t('forms.custom_templates.data_collection.type_values.satisfaction'),
        effectiveness: i18n.t('forms.custom_templates.data_collection.type_values.effectiveness'),
        knowledge: i18n.t('forms.custom_templates.data_collection.type_values.knowledge'),
      },
      colorMapping: {
        satisfaction: 'yellow',
        effectiveness: 'malibu',
        knowledge: 'purple',
      },
    },
    [TableColumnType.Status]: {
      valueMapping: {
        draft: i18n.t('forms.custom_templates.data_collection.status_values.draft'),
        active: i18n.t('forms.custom_templates.data_collection.status_values.published'),
      },
      colorMapping: {
        draft: 'neutral',
        active: 'positive',
      },
    },
  }
  return (
    <OneModal isOpen onClose={handleCancel}>
      <OneModal.Header title={i18n.t('forms.custom_templates.data_collection.title')} />
      <OneModal.Content withPadding>
        <Box padding="s12" width="full" justifyContent="center" alignItems="center">
          <FormsTemplatesDataCollection
            resourceType={'Trainings::Training'}
            columns={columns}
            onlyRead
            mode="list"
            onlyActive
            configurations={configurations}
            createRoute={navigation.trainings.list.surveyTemplates.list.newTemplate.fullPath()}
            itemOnClick={itemOnClick}
          />
        </Box>
      </OneModal.Content>
    </OneModal>
  )
}

export default SelectTemplateFormModal
